import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Col, Popconfirm, Row, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { ReactComponent as DeleteIcon } from "../../../assets/delete-icon.svg";
import SpinnerComponent from "../../../components/spinner";
import { deleteLabAttach } from "../redux/actions";
import axios from "axios";
import { baseURL } from "../../../globalUtils/axiosConfig";

const AttachmentsSection = ({ isEdit, loading, documents, setDocuments, currentLab, disabled = false }) => {  
  const [delAttachKey, setDelAttachKey] = useState([]);
  const inputFile = useRef(null);

  const dispatch = useDispatch();

  const { deleteAttachLoading, createLabLoading } = useSelector(
    (state) => state.labsSetupReducer
  );
  
  const handleShowImage = async (image) => {
    console.log("image", image);
    
    if (image.isLocal) {
      // For local files
      let url = URL.createObjectURL(image);
      window.open(url, "_blank");
    } else {
      try {
        const hideLoading = message.loading("Opening attachment...", 0);
        
        const response = await axios({
          url: image.image,
          method: 'GET',
          responseType: 'blob',
        });
  
        const mimeType = response.headers['content-type'] || 'application/octet-stream';
        
        const blob = new Blob([response.data], { type: mimeType });
        const url = window.URL.createObjectURL(blob);
  
        const a = document.createElement('a');
        a.href = url;
        
        if (mimeType.startsWith('image/') || mimeType === 'application/pdf') {
          a.target = '_blank';  
        } else {
          a.download = image.name || `attachment_${Date.now()}`; 
        }
  
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
  
        setTimeout(() => window.URL.revokeObjectURL(url), 60000);
        
        hideLoading();
      } catch (error) {
        console.error('Error fetching attachment:', error);
        message.error(`Failed to load attachment: ${error.response?.data?.message || error.message}`);
      }
    }
  };

  const changeHandler = (event) => {
    // event.currentTarget.value = null;

    if (event.target.files.length < 1) {
      return;
    }

    Object.entries(event.target.files).forEach((item) => {
      console.log(item);
      item[1]["key"] = Math.round(Math.random() * 1000000);
      item[1]["isLocal"] = true;
      console.log("item[1]", item[1]);
      setDocuments((prev) => [...prev, item[1]]);
    });
  };

  const handleDeleteImage = (record) => {
    console.log("currentLab", currentLab);

    if (record?.isLocal) {
      // For local files, just filter them out
      let filteredImages = documents.filter(
        (image) => image.key !== record.key
      );
      setDocuments(filteredImages);
    } else {
      if (!currentLab?.id) {
        console.error("Lab ID not found");
        return;
      }
      
      setDelAttachKey([...delAttachKey, record.key]);
      
      let filteredImages = documents.filter(
        (image) => image.key !== record.key
      );
      setDocuments(filteredImages);
      
      const payload = {
        labId: currentLab.id,
        attachmentId: record.key
      };
      
      dispatch(deleteLabAttach(payload));
    }
  };

  return (
    <Col md={22} lg={20} xl={18} xxl={18} style={{ paddingLeft: "0px" }}>
      <div className="lab-attach-parent-div">
        <span className="text-span">ATTACHMENTS</span>
       
      </div>
      <Row gutter={[20, 10]} className="attach-listing-div add-attach-btn">
        {documents.map((el) => {
          return (
            <Col span={24}>
              <Row justify="space-between">
                <Col
                  span={20}
                  onClick={() => handleShowImage(el)}
                  className="name-col"
                >
                  <span className="name">
                    {el.name.replaceAll(/[^a-zA-Z0-9.-]/g, " ")}
                  </span>
                </Col>
                <Col span={4}>
                  {deleteAttachLoading && delAttachKey.includes(el?.key) ? (
                    <SpinnerComponent fontSize={14} />
                  ) : (
                    <Popconfirm
                      title="Are you sure you want to delete this Attachment?"
                      onConfirm={() => handleDeleteImage(el)}
                      okText="Yes"
                      cancelText="No"
                    >
                      {isEdit && <DeleteIcon className="del-icon" />}
                    </Popconfirm>
                  )}
                </Col>
              </Row>
            </Col>
          );
        })}
      </Row>
       <div className={`img-parent-div ${isEdit && "edit-image"}`}>
          {isEdit && (
            <div className="edit-icon-div">
              <input
                readOnly={loading}
                disabled={!isEdit || loading || disabled}
                type="file"
                name="profileImg"
                id="profileImg"
                accept="doc/docx/xls/xlsx/ppt/pptx/pdf/jpg/jpeg/gif/png/mp4"
                style={{ display: "none" }}
                onChange={changeHandler}
                multiple
                // accept="*"
                ref={inputFile}
              />
              <label htmlFor="profileImg">
                <Button
                  icon={<PlusOutlined />}
                  className="add-activity-btn "
                  size="middle"
                  onClick={() => inputFile.current.click()}
                  loading={createLabLoading}
                >
                  Attachment
                </Button>
              </label>
            </div>
          )}
        </div>
    </Col>
  );
};

export default AttachmentsSection;
